import { render, staticRenderFns } from "./VisionboardChallengeSidebar.vue?vue&type=template&id=0dd162cf&"
import script from "./VisionboardChallengeSidebar.vue?vue&type=script&lang=js&"
export * from "./VisionboardChallengeSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports